export default process.env.NODE_ENV === 'development'
  ? require('./App.dev').default
  : require('./App.prod').default;
